<template>
  <div
    class="px-4 py-2 cursor-pointer transition-all text-center text-white bg-light-green border border-solid border-[#5e9822] hover:text-light-green hover:bg-white text-base"
  >
    <slot />
  </div>
</template>

<script setup lang="ts"></script>
